import { Component, Inject, HostListener, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'src/ngx-blockui/decorators/block-ui.decorator';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as _ from 'lodash';

import { AppService } from '../../app.service';
import { EntityService } from '../../_core/entity.service';

@Component({
    selector: 'app-navepx-dialog',
    templateUrl: './navepx-dialog.component.html',
    styleUrl: './navepx-dialog.component.scss',
    standalone: false
})
export class NavepxDialogComponent implements AfterViewInit {
	@BlockUI() blockUI: NgBlockUI;
	@HostListener('window:message', ['$event']) onMessage(e) {
		console.log("NAVEPX MESSAGE", e.data);
		if (e.data?.isTabit) {
			this.dialogRef.close({ mode: "success", data: e.data });
		}
	}
	CUSTOM_CSS_URL
	CUSTOM_JAVASCRIPT_URL

	trustedIframeUrl: SafeResourceUrl;
	args: any = {}
	constructor(
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<NavepxDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.redirectURL);
		this.blockUI.start();
		this.args = this.data.providerData || {};
		//this.CUSTOM_CSS_URL = `https://developer.paymentshub.com/demo-files/epx-hosted-pay-page/payPage.css`;
		//this.CUSTOM_CSS_URL = `${this.appService.appConfig.host}/assets/nabepx/paypage.css`;
		this.CUSTOM_JAVASCRIPT_URL = `${this.appService.appConfig.host}assets/nabepx/paypage.js`;
	}

	ngAfterViewInit() {
		this.blockUI.start();
		const sendToken = document.getElementById('send_token') as HTMLFormElement;
		if (sendToken) {
			sendToken.setAttribute('action', this.data.redirectURL);
			sendToken.setAttribute('target', 'add_payment');
			sendToken.submit();
		}
	}


	onFrameLoaded(ev) {
		this.blockUI.stop();
		try {
			let _location = ev.currentTarget.contentWindow.location;
			if (_location.href) {
				if (_location.href.indexOf('/finance/transaction-page') != -1) {

				}
			}
		} catch (e) {

		}

	}
}
